import { IQuota } from '../types/quota.types';

export const getQuota = (headers: { [key: string]: string }): IQuota => {
  return {
    totalBytes: parseInt(headers['x-quota-total-bytes']),
    usedBytes: parseInt(headers['x-quota-used-bytes']),
  };
};
